import { imagebossUrl } from './imageboss';

const PLACEHOLDER =
  '<div class="rep-form__image"><svg class="icon icon-log-in"><use xlink:href="#icon-log-in"></use></svg></div>';

let watchingPhotoErrors = false;

// Rep photos live on the legacy PHP site. ImageBoss resizes and caches them,
// so visitors never request them from PHP directly.
export const repPhotoMarkup = src => {
  if (!src) return PLACEHOLDER;

  const photoUrl = imagebossUrl(src, { width: 180 });
  return `<img class="rep-form__image lazy" src="${photoUrl}" alt="">`;
};

// Error events don't bubble, so one capturing listener covers every rep card,
// including cards rebuilt with innerHTML. ImageBoss fails when no photo exists.
export const swapFailedRepPhotos = () => {
  if (watchingPhotoErrors) return;
  watchingPhotoErrors = true;

  document.addEventListener(
    'error',
    event => {
      if (event.target.matches?.('img.rep-form__image')) {
        event.target.outerHTML = PLACEHOLDER;
      }
    },
    true
  );
};
